import * as Headspace from 'headspace'; // eslint-disable-line
/* global Swiper */ // Tell ESLint that Swiper is a global variable

export default {
  init() {
    // JavaScript to be fired on all pages
    Headspace(document.querySelector('header'), { // can use factory method or `new Headspace`
      startOffset: 90,                            // default: height of element
      tolerance: 5,                               // default: 8
      showAtBottom: false,                        // default: true
      classNames: {
        base: 'headspace',                           // default: 'headspace'
        fixed: 'headspace--fixed',                   // default: 'headspace--fixed'
        hidden: 'headspace--hidden',                 // default: 'headspace--hidden'
      },
    });


    $('.page-header__carousel').owlCarousel({
      items: 1,
      loop: false,
      margin: 0,
      nav: false,
      dots: true,
      onChanged: changePageHeaderProd,
    });

    function changePageHeaderProd() {
      setTimeout(function () {
        $('.page-header__images .owl-dots .page-header__product').remove();
        if ($('.page-header__images .owl-item.active .page-header__product').length != 0) {
          $('.page-header__images .owl-item.active .page-header__product').clone().appendTo('.page-header__images .owl-dots');
        }
      }, 100);
    }


    $('.image_and_text').each(function () {
      if ($('.image_and_text__product ', this).length > 0) {
        $('.image_and_text__content', this).append('<div class="product-info"></div>');
      }
    });

    $('.image_and_text__carousel').owlCarousel({
      items: 1,
      loop: false,
      margin: 0,
      nav: true,
      dots: true,
      onChanged: viewProd,
    });

    function viewProd(event) {
      var thisSlide = event['currentTarget'];
      var thisParent = $(thisSlide).parent();
      $('.product-info', thisParent).text('');
      var trololoo = $('.owl-item:eq(' + event.item.index + ')', thisParent);
      if ($(trololoo).find('.image_and_text__product').length != 0) {
        var productInfo = $(trololoo).find('.image_and_text__product').html();
        $('.product-info', thisParent).html(productInfo);
      }
    }

    // Show/hide mobile menu
    function mobileMenu(open) {
      $('#menu-toggle').toggleClass('open', open);
      $('.nav-primary').toggleClass('open', open);
      $('body').toggleClass('menu-open', open);
    }

    // Show/hide search flyout
    function searchFlyout(open) {
      $('#search-toggle').toggleClass('open', open);
      $('#search-flyout').toggleClass('open', open);
      $('body').toggleClass('menu-open', open);
      if (open) {
        $('#search-flyout .search-field').focus();
      } else {
        $('#search-flyout .search-field').blur();
      }
    }

    // Bind search toggle
    $('#search-toggle').on('click', function () {
      mobileMenu(false);
      searchFlyout(!$(this).hasClass('open'));

      // Bind blur click
      $(document).on('click', function (event) {
        if (!$(event.target).closest('#search-flyout, #search-toggle').length) {
          if ($('#search-toggle').hasClass('open')) {
            searchFlyout(false);
          }
        }
      });
    });

    // Close search flyout
    $('#close-flyout').on('click', function () {
      searchFlyout(false);
    });

    // Mobile menu toggle
    $('#menu-toggle').on('click', function () {
      searchFlyout(false);
      mobileMenu(!$(this).hasClass('open'));
    });

    // Mobile menu accordion
    $('.nav-primary .expand').on('click', function () {
      $(this).closest('li').toggleClass('open');
      $(this).siblings('.sub-menu').slideToggle();
    });

    // Mega menu hover
    $('.nav-primary .shop-page').hover(function () {
      $(this).addClass('hover');
    }, function () {
      $(this).removeClass('hover');
    });

    // Search form
    $('.search-form .icon-search').on('click', function (event) {
      event.preventDefault();
      $('.search-form').submit();
    });

    // faq qa
    $('.qa__q').click(function () {
      $(this).parent('.qa__item').toggleClass('open');
      $(this).next('.qa__a').slideToggle(200);
    });

    // Product category toggle thing
    $('.category-nav .toggle').on('click', function () {
      $(this).closest('li').toggleClass('open');
      $(this).siblings('.sub-menu').slideToggle();
    });
    $('.category-nav .active').addClass('open').siblings('.sub-menu').slideToggle();
    $('.category-nav .open > .sub-menu').each(function () {
      $(this).slideDown(0);
    });

    // Product Carousel initialization
    this.initProductCarousel();
  },

  initProductCarousel() {
    const carousels = document.querySelectorAll('.product-carousel__swiper');
    
    carousels.forEach((carousel, index) => {
      // Add unique ID to each carousel for proper targeting
      const carouselId = `product-carousel-${index}`;
      carousel.setAttribute('id', carouselId);
      
      // Get the parent product-carousel element
      const carouselContainer = carousel.closest('.product-carousel');
      
      // Get the navigation elements
      const prevButton = carouselContainer.querySelector('.swiper-button-prev');
      const nextButton = carouselContainer.querySelector('.swiper-button-next');
      
      // Add unique classes to the navigation elements
      const prevClass = `${carouselId}-prev`;
      const nextClass = `${carouselId}-next`;
      prevButton.classList.add(prevClass);
      nextButton.classList.add(nextClass);
      
      // Initialize Swiper with the specific navigation
      new Swiper(carousel, {
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
          nextEl: `.${nextClass}`,
          prevEl: `.${prevClass}`,
        },
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 5,
          },
        },
        on: {
          init: function() {
            // Update navigation buttons visibility
            const swiper = this;
            
            function updateButtons() {
              prevButton.style.display = swiper.isBeginning ? 'none' : 'flex';
              nextButton.style.display = swiper.isEnd ? 'none' : 'flex';
            }
            
            updateButtons();
            swiper.on('slideChange', updateButtons);
          }
        }
      });
    });
  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Bind carousels
    $('.owl-carousel').owlCarousel({
      items: 1,
      loop: true,
      margin: 10,
      nav: true,
      dots: true,
    });

    // Reinitialize product carousels after AJAX loads
    $(document).ajaxComplete(() => {
      this.initProductCarousel();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js